const GUEST_SESSION_STORAGE_KEY = 'guestSessionId';

/**
 * A random id identifying this browser tab's guest visit, used only to group a
 * guest's own analytics events (home page -> mission play -> puzzle solved) into
 * one funnel in the logs - never to identify a person or to track them across
 * visits/devices.
 *
 * sessionStorage (not localStorage or a cookie) deliberately, mirroring
 * inventoryAPI.js's guestRoomInventory: the id must not outlive the current
 * tab/session. That keeps it a non-persistent, internal-operations-only
 * identifier rather than something that could re-identify a returning guest,
 * which is what COPPA's exception for anonymous analytics ids requires.
 */
export const getGuestSessionId = () => {
  try {
    let id = sessionStorage.getItem(GUEST_SESSION_STORAGE_KEY);
    if (!id) {
      id = typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(GUEST_SESSION_STORAGE_KEY, id);
    }
    return id;
  } catch (error) {
    return null;
  }
};
